import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const organisationRecordSalesTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.record.sales-trend",
  name: "Sales order value",
  description: "Sales order value across the selected period.",
  apps: [
    "configuration",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "revenue",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Order value",
        query: {
          version: 1,
          source: "sales.analysis",
          ...period(30),
          select: [
            {
              type: "field",
              field: "order_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "revenue",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "order_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Sales order value",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
